// Lets other parts of the app wait for the cold-start LoadingScreen to finish.
//
// The overlay sits at zIndex 9999 for at least 3s, so anything that animates
// in underneath it (the badge celebration) plays unseen. AppWithLoader has
// always recorded the end of the splash in sessionStorage; this adds an event
// so a listener doesn't have to poll for it.

const KEY = 'splash_shown';
const EVENT = 'dspcafe:splash-done';

export function isSplashDone() {
  try {
    return Boolean(sessionStorage.getItem(KEY));
  } catch {
    return true; // storage blocked: the splash can't track itself either
  }
}

export function markSplashDone() {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    // private mode — the event below still fires
  }
  window.dispatchEvent(new Event(EVENT));
}

export function onSplashDone(callback) {
  window.addEventListener(EVENT, callback);
  return () => window.removeEventListener(EVENT, callback);
}
